import { io } from "socket.io-client";
import { useEffect } from "react";
import { aqua_socket_url } from "../../utils/Enviroment";

const SOCKET_URL = aqua_socket_url;

const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
});

export const useSocketEvents = (events) => {
    useEffect(() => {
        const eventHandlers = [];
        events.forEach(({ eventName, handler }) => {
            socket.on(eventName, handler);
            eventHandlers.push({ eventName, handler });
        });
        return () => {
            eventHandlers.forEach(({ eventName, handler }) => {
                socket.off(eventName, handler);
            });
        };
    }, [socket, events]);
}

export default socket;
